export default __webpack_public_path__ + "static/media/brandon.99b536f1.png";